function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M226.9,437.1l-43.2-12.5c-4.5-1.3-7.1-6-5.8-10.6l96.7-333.2c1.3-4.5,6-7.1,10.6-5.8l43.2,12.5c4.5,1.3,7.1,6,5.8,10.6 l-96.7,333.2C236.1,435.8,231.4,438.4,226.9,437.1z M116.9,357.6l30.8-32.9c3.3-3.5,3-9-0.6-12.2L82.9,256l64.2-56.5 c3.6-3.2,3.9-8.7,0.6-12.2l-30.8-32.9c-3.2-3.4-8.6-3.6-12-0.4L2.7,249.8c-3.6,3.3-3.6,9.1,0,12.4l102.1,95.7 C108.3,361.2,113.7,361,116.9,357.6L116.9,357.6z M407.2,358l102.1-95.7c3.6-3.3,3.6-9.1,0-12.4L407.2,154c-3.4-3.2-8.8-3-12,0.4 l-30.8,32.9c-3.3,3.5-3,9,0.6,12.2l64.2,56.5l-64.2,56.5c-3.6,3.2-3.9,8.7-0.6,12.2l30.8,32.9C398.3,361,403.7,361.2,407.2,358 L407.2,358z"
});

function SvgCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.12f56701.svg";
export { ForwardRef as ReactComponent };